import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './App.css'
import App from './App.tsx'
import { initializeTheme } from './store/theme'

// Initialize theme before rendering to prevent flash
initializeTheme();

// Configure QueryClient with better defaults for real-time updates
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Shorter stale time for more responsive updates
      staleTime: 30 * 1000, // 30 seconds
      // Shorter garbage collection time
      gcTime: 5 * 60 * 1000, // 5 minutes
      // Refetch when window regains focus for fresh data
      refetchOnWindowFocus: true,
      // Retry failed requests
      retry: 1,
      // Background refetch for stale data
      refetchOnMount: 'always',
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
)
